import { Table, NavLink, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './MercurXProjectCard.scss';
import MercurXIcons from '../MercurXIcons/MercurXIcons';
import { mainColors } from '../../helpers/colors';
import mercurxMiniIcon from '../../assets/img/logo/mercurx-logo-mini.png';
import mercurxCardDefaultLogo from '../../assets/img/logo/mercurx-logo-white.png';
import { useEffect, useState } from 'react';

const CARD_PROGRESS_BAR_VALUE_WIDTH = 37;

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function resolveSaleAsset(project) {
  const hasToken = Boolean(project?.token);
  const hasNft = Boolean(project?.nft);

  if (hasNft && !hasToken) {
    return {
      asset: project.nft,
      isNftSale: true,
    };
  }

  return {
    asset: project?.token || project?.nft || null,
    isNftSale: false,
  };
}

export default function Card1(props) {
  const { item } = props;
  const project = item?.[1] || {};
  const { asset: saleAsset, isNftSale } = resolveSaleAsset(project);

  const [projectCardRef, setProjectCardRef] = useState(null);
  const [, setViewportSize] = useState([0, 0]);

  function updateSize() {
    setViewportSize([window.innerWidth, window.innerHeight]);
  }

  useEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  const logoOnErrorHandler = (event) => {
    event.currentTarget.src = mercurxCardDefaultLogo;
    event.currentTarget.className = 'project-icon';
  };

  function getProgressBarValueStyle() {
    const projectCardLeft = projectCardRef?.offsetLeft;
    const projectCardWidth = projectCardRef?.offsetWidth;

    return {
      left: projectCardLeft + projectCardWidth / 2 - CARD_PROGRESS_BAR_VALUE_WIDTH / 2,
    };
  }

  function getProjectDetailRoute(projectData) {
    const projectId = projectData?.id;
    if (!projectId) {
      return '/sales/token';
    }

    if (projectData?.nft && !projectData?.token) {
      return `/sales/nft/project/${projectId}`;
    }
    if (projectData?.token && !projectData?.nft) {
      return `/sales/token/project/${projectId}`;
    }

    const currentPathname = window.location.pathname.toLowerCase();

    if (currentPathname.startsWith('/sales/nft')) {
      return `/sales/nft/project/${projectId}`;
    }

    return `/sales/token/project/${projectId}`;
  }

  const assetSymbol = saleAsset?.symbol || (isNftSale ? 'NFT' : 'TOKEN');
  const priceInMerx = toNumber(saleAsset?.price_in_mercurx);
  const totalRaised = toNumber(project?.total_raised);
  const percentRaised = toNumber(project?.percent_raised);
  const numberOfRegistrations = toNumber(project?.number_of_registrations);
  const priceInUsd = toNumber(saleAsset?.price_in_usd);
  const totalSold = toNumber(project?.total_tokens_sold);
  const totalSupply = toNumber(saleAsset?.total_supply);
  const isSaleEnded = project?.round_sale?.end_date
    ? new Date() > new Date(project.round_sale.end_date)
    : false;

  return (
    <Col
      ref={(newRef) => setProjectCardRef(newRef)}
      className="d-flex flex-column pb-4"
      lg={4}
      sm={12}
      md={6}
    >
      <NavLink as={Link} to={getProjectDetailRoute(project)} className="shadow">
        <div
          className="project-img-div pt-5"
          style={{
            background: `linear-gradient(
              rgba(0, 0, 0, 0.5),
              rgba(0, 0, 0, 0.5)
            ),url(${process.env.REACT_APP_API_URL + '/projects/' + project?.id + '/image'})`,
            backgroundSize: 'cover',
          }}
        >
          <div className="d-flex pt-4 text-ultra-light align-items-center ">
            <div className="ps-3 pe-2 pt-1">
              <img
                alt="project-icon"
                src={process.env.REACT_APP_API_URL + '/projects/' + project?.id + '/logo'}
                className="project-icon"
                onError={logoOnErrorHandler}
              />
            </div>
            <div className="ps-3 pe-3 ">
              <div className="text-fs-project-name card-project-name">{project?.name}</div>
              <div className="text-fs-head-sm">{`1 ${assetSymbol} = ${priceInMerx} MERX`}</div>
            </div>
          </div>
        </div>
        <div className="d-flex text-fs-body-md ps-2 pt-3">
          Total Raised:
          <div className="text-primary text-fs-head-md ps-2">
            {' '}
            {totalRaised.toLocaleString('tr-TR', {
              style: 'currency',
              currency: 'USD',
              currencyDisplay: 'symbol',
              useGrouping: true,
              minimumFractionDigits: 2,
            })}
          </div>
          {isSaleEnded ? (
            <div className="ms-auto d-flex align-items-center ">
              <div
                className="ended-logo px-3 me-1 d-flex align-items-center
                                          text-fs-body-sm"
              >
                Ended
              </div>
              <img
                className="mercurx-icon ms-1 me-1"
                alt="mercurx-mini-icon"
                src={mercurxMiniIcon}
              />
            </div>
          ) : (
            <img
              className="mercurx-icon ms-auto mt-2 me-1 d-flex align-items-center "
              alt="mercurx-mini-icon"
              src={mercurxMiniIcon}
            />
          )}
        </div>

        <div className="progress mb-2 mx-2 mt-2 rounded-pill">
          <span
            className="card-progress-value
          text-t-body-color-light"
            style={getProgressBarValueStyle()}
          >
            {percentRaised}%
          </span>
          <div
            className="progress-bar
           rounded-pill"
            style={{ width: `${percentRaised}%` }}
          ></div>
        </div>

        <Table>
          <tbody>
            <tr>
              <td className="text-fs-body-md">Registrations</td>
              <td className="text-fs-body-lg text-end text-primary">
                {numberOfRegistrations.toLocaleString('tr-TR', {
                  useGrouping: true,
                })}
              </td>
            </tr>
            <tr>
              <td className="text-fs-body-md ">{isNftSale ? 'NFT Price' : 'Token Price'}</td>
              <td className="text-fs-body-lg text-end text-primary">
                {priceInUsd.toLocaleString('tr-TR', {
                  style: 'currency',
                  currency: 'USD',
                  currencyDisplay: 'symbol',
                  useGrouping: true,
                  minimumFractionDigits: 4,
                })}
              </td>
            </tr>
            <tr>
              <td className="text-fs-body-md">Start Date</td>

              <td className="text-fs-body-lg text-end text-primary">
                {project?.round_sale?.start_date
                  ? new Date(project.round_sale.start_date).toLocaleDateString()
                  : '-'}
              </td>
            </tr>
          </tbody>
        </Table>
        <Table>
          <tbody className="text-fs-tag">
            <tr>
              <td>
                <div className="d-flex align-items-center">
                  <MercurXIcons
                    name="BiCoin"
                    color={mainColors['primary']}
                    size="25"
                    className="me-2"
                  />
                  <div className="d-flex flex-column align-items-start">
                    <div>
                      {isNftSale ? 'NFT Sold: ' : 'Token Sold: '}
                      <span className="text-primary">
                        {' '}
                        {totalSold.toLocaleString('tr-TR', {
                          useGrouping: true,
                          minimumSignificantDigits: 1,
                        })}
                      </span>
                    </div>
                    <div>
                      {isNftSale ? 'Total NFTs:' : 'Total Tokens:'}
                      <span className="text-primary">
                        {' '}
                        {totalSupply.toLocaleString('tr-TR', {
                          useGrouping: true,
                          minimumSignificantDigits: 1,
                        })}
                      </span>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div className="d-flex d-flex align-items-center justify-content-end">
                  <MercurXIcons
                    name="BiTimeFive"
                    color={mainColors['primary']}
                    size="25"
                    className="me-2"
                  />

                  <div
                    className="d-flex flex-column align-items-start
                          justify-content-center"
                  >
                    {isSaleEnded ? <>Sale Ended</> : <> On Sale</>}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </NavLink>
    </Col>
  );
}
